import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ConsultSuccess from "@/pages/ConsultSuccess";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import SmsOptIn from "@/pages/SmsOptIn";
import { AuthProvider, useAuth } from "@/context/AuthContext";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", color: "var(--muted)", fontFamily: "var(--mono)", fontSize: 11, letterSpacing: ".14em" }}>LOADING...</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/sms-opt-in" element={<SmsOptIn />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Protected><AdminDashboard /></Protected>} />
            <Route path="/consult/success" element={<ConsultSuccess />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
